// extracted by mini-css-extract-plugin
export var chevron = "index-module--chevron--bc326";
export var contactInfo = "index-module--contactInfo--8832d";
export var isMobileLink = "index-module--isMobileLink--62ba7";
export var links = "index-module--links--375af";
export var schoolMeta = "index-module--schoolMeta--233f5";
export var schoolMetaRTLContainer = "index-module--schoolMetaRTLContainer--0be9f";
export var servicesTabRTL = "index-module--servicesTabRTL--ac93a";
export var strapAlign = "index-module--strapAlign--c68ff";
export var wrapText = "index-module--wrapText--3c1af";